import { NAME } from './constants';

export const NEW_NOTIFICATION = `${NAME}/NEW_NOTIFICATION`;
export const NEW_TOKEN = `${NAME}/NEW_TOKEN`;
export const MARK_AS_CLOSED = `${NAME}/MARK_AS_CLOSED`;
export const MARK_AS_ENTERED = `${NAME}/MARK_AS_ENTERED`;
export const CLEAR_NOTIFICATIONS = `${NAME}/CLEAR_NOTIFICATIONS`;
